import { Modal } from 'antd';
import type React from 'react';
import type { PatientDataInput } from '../../graphql/generated/graphql.ts';
import { patientFullName } from '../../utils/patient.ts';
import { Forms } from './Forms.tsx';

export const FormsModal: React.FC<{ patientData: PatientDataInput | null; onClose: () => void }> = ({ patientData, onClose }) => (
  <Modal
    title={`Formulare für ${patientData && patientFullName(patientData)}`}
    width={768}
    open={!!patientData}
    footer={null}
    onCancel={onClose}
    destroyOnHidden
  >
    {patientData && <Forms patientData={patientData} />}
  </Modal>
);
